import { NextRouter, withRouter } from 'next/router';
import React, { FunctionComponent, useState } from 'react';
import { OptInType } from '../../../domain/optInType';
import { WebIntent } from '../../../services/dtos/webIntent';
import { OptIn } from '../../../services/dtos/optIn';
import { createWebIntent } from '../../../services/web-intents/webIntent';
import IntentForm, { IntentFormModel, IntentFormProps } from '../../components/intent-form/IntentForm';
import getTrafficSource from '../../utils/traffic-source/getTrafficSource';

export const DEFAULT_ERROR_MESSAGE = 'Non è stato possibile inviare la richiesta';
export const DEFAULT_SUCCESS_MESSAGE = 'Grazie di averci contattato. Un agente ti ricontatterà a breve.';

export interface CreateIntentProps {
  id: string | number,
  router: NextRouter,
  formProps?: Omit<IntentFormProps, 'loading' | 'errorMessage' | 'successMessage' | 'onSubmit'>,
  onSuccess?: (intent: WebIntent) => void,
}

export const CreateWebIntent: FunctionComponent<CreateIntentProps> = ({
  id,
  router,
  formProps = {},
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [successMessage, setSuccessMessage] = useState<string | undefined>();

  const onSubmit = async (values: IntentFormModel) => {
    setLoading(true);

    try {
      const optIns: OptIn[] = [{
        type: OptInType.SERVICE,
        source: 'WEB',
      }];

      if (values.marketing) {
        optIns.push({
          type: OptInType.MARKETING,
          source: 'WEB',
        });
      }

      if (values.thirdParties) {
        optIns.push({
          type: OptInType.THIRD_PARTIES,
          source: 'WEB',
        });
      }

      const result = await createWebIntent({
        id: values.id || undefined,
        listingId: +id,
        name: values.name,
        email: values.email,
        phoneNumber: values.phoneNumber,
        source: getTrafficSource(router.query) as string,
        optIns,
      });

      if (onSuccess) {
        onSuccess(result);
      }

      setSuccessMessage(DEFAULT_SUCCESS_MESSAGE);
    } catch (e) {
      setErrorMessage(DEFAULT_ERROR_MESSAGE);
    }
    setLoading(false);
  };

  return (
    <IntentForm
      {...formProps}
      onSubmit={onSubmit}
      loading={loading}
      successMessage={successMessage}
      errorMessage={errorMessage}
    />
  );
};

export default withRouter(CreateWebIntent);
